/**
 * Elenco delle categorie estratte dal foglio "PROVA PER BILACIO.xlsx" con i
 * relativi colori di riempimento. Questi colori rappresentano diversi
 * raggruppamenti di spesa/entrata e saranno utilizzati per aggregare i
 * valori nel riepilogo annuale del Modulo D.
 */
const categories = [
  // Categorie di tipo "Uscita"
  { name: 'ACQUISTO VEICOLI', color: '#92D050', type: 'Uscita' },
  { name: 'ASSICURAZIONI', color: '#FFC000', type: 'Uscita' },
  { name: 'ATTREZZATURE', color: '#00B0F0', type: 'Uscita' },
  { name: 'AUTOSTRADA', color: '#00B0F0', type: 'Uscita' },
  { name: 'CANONI RADIO', color: '#FFC000', type: 'Uscita' },
  { name: 'CARBURANTE', color: '#FFFF00', type: 'Uscita' },
  { name: 'ENERGIA', color: '#FFC000', type: 'Uscita' },
  { name: 'FERRAMENTA', color: '#FFFF00', type: 'Uscita' },
  { name: 'GAS', color: '#FFC000', type: 'Uscita' },
  { name: 'MANUTENZIONE ATTREZZATURE', color: '#FFC000', type: 'Uscita' },
  { name: 'MANUTENZIONE MEZZI', color: '#FFC000', type: 'Uscita' },
  { name: 'MATERIALE CONSUMO', color: '#FFFF00', type: 'Uscita' },
  { name: 'MATERIALE ELETTRICO', color: '#FFFF00', type: 'Uscita' },
  { name: 'MATERIALE MEZZI', color: '#FFFF00', type: 'Uscita' },
  { name: 'PRANZI', color: '#00B0F0', type: 'Uscita' },
  { name: 'SPESE CC', color: '#00B0F0', type: 'Uscita' },
  { name: 'SPESE PRATICHE', color: '#FFC000', type: 'Uscita' },
  { name: 'TELEFONIA', color: '#FFC000', type: 'Uscita' },
  { name: 'VARIE', color: '#FFFF00', type: 'Uscita' },
  { name: 'VESTIARIO', color: '#92D050', type: 'Uscita' },
  { name: 'VISITE MEDICHE', color: '#00B0F0', type: 'Uscita' },
  { name: 'AFFILIAZIONI', color: '#FFC000', type: 'Uscita' },
  { name: 'ALIMENTI/BEVANDE', color: '#FFFF00', type: 'Uscita' },
  { name: 'MANUTENZIONE IMMOBILI', color: '#00B0F0', type: 'Uscita' },
  { name: 'MATERIALE UFFICIO', color: '#FFFF00', type: 'Uscita' },
  { name: 'REVISIONI', color: '#FFC000', type: 'Uscita' },
  { name: 'RIMBORSI', color: '#FFFF00', type: 'Uscita' },
  { name: 'SPESE MANIFESTAZIONE', color: '#FFC000', type: 'Uscita' },
  { name: 'SPESE POSTALI', color: '#FFC000', type: 'Uscita' },
  { name: 'TASSE', color: '#00B0F0', type: 'Uscita' },

  // Categorie di tipo "Entrata"
  { name: 'ENTRATE DA DONAZIONI', color: '#2bb673', type: 'Entrata' },
  { name: 'ENTRATE DA RACCOLTE FONDI', color: '#33a1ff', type: 'Entrata' },
  { name: 'ENTRATE DA SPONSORIZZAZIONI', color: '#ff5733', type: 'Entrata' },
  { name: 'ENTRATE PER PRESTAZIONI', color: '#f1c40f', type: 'Entrata' },
  { name: 'CONTRIBUTI DA ENTI PUBBLICI', color: '#e74c3c', type: 'Entrata' },
  { name: 'ENTRATE DA VENDITE', color: '#8e44ad', type: 'Entrata' },
];

export default categories;
